/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { ReactComponent as CheckIcon } from '../../../../common/svg/general/green-check.svg';
import { ReactComponent as XIcon } from '../../../../common/svg/general/icon-x.svg';
import { Button } from '../../../core/button/Button';
import styles from './StakeModal.module.css';

export interface ModalFinishStateProps {
  header: string;
  transactionUrl: string;
  handleClose: () => void;
}

export const ModalFinishState: React.FC<ModalFinishStateProps> = props => {
  return (
    <>
      <div className={`${styles.modalBG2} max-w-screen-sm lg:max-w-full`}>
        <div className={styles.xIconBG} onClick={props.handleClose}>
          <XIcon className={styles.xIcon} />
        </div>
        <div>
          <div className={`${styles.title} fontVanguard font-bold text-center`}>
            {props.header}
          </div>
          <hr className={styles.titleHR} />
          <div className="text-left">
            <div className="flex flex-col w-full justify-center text-center pt-8">
              <div>
                <div className="mb-10">
                  <CheckIcon className={styles.greenCheck} />
                </div>
                <div className={`${styles.transactionTitle} mb-5`}>
                  Transaction Submitted
                </div>
                <div className="mb-20">
                  <a
                    href={props.transactionUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'underline' }}
                  >
                    View Transaction on Explorer
                  </a>
                </div>
              </div>
              <Button fullWidth onClick={props.handleClose} label="Done" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
